<template>
    <div class="bjjswe">
		<div v-if="!showDetail" class="iusjjs">
		    <secret @orderId="getOrderId"></secret>
			<div class="bujss">
				<h6 class="joid">订单列表</h6>
				<div class="juidj">
					<el-input
						placeholder="订单编号"
						v-model="input1">
					</el-input>
					<el-date-picker
					  v-model="date"
					  type="daterange"
					  range-separator="至"
					  start-placeholder="开始日期"
					  end-placeholder="结束日期">
					</el-date-picker>
					<el-select v-model="repayType" placeholder="支付方式">
						<el-option
						  v-for="item in options01"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value">
						</el-option>
					</el-select>
					<el-select v-model="payState" placeholder="支付状态">
						<el-option
						  v-for="item in options02"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value">
						</el-option>
					</el-select>
					<el-select v-model="fapiao" placeholder="开票状态">
						<el-option
						  v-for="item in options03"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value">
						</el-option>
					</el-select>
					<div class="rtgh" @click="goSearch">查询</div>
				</div>
				<div class="ryyh">
					<el-table
					    :data="tableData"
					    style="width: 100%">
					    <el-table-column
					      label="订单编号"
					      width="200">
						  <template slot-scope="scope">
							{{ scope.row.chargeOrderNo }}
						  </template>
					    </el-table-column>
					    <el-table-column
					      label="订单金额（元）"
					      width="140">
					      <template slot-scope="scope">
							{{ scope.row.amount }}
					      </template>
					    </el-table-column>
						<el-table-column
						  label="订单时间"
						  width="170">
						  <template slot-scope="scope">
							{{ scope.row.orderTime }}
						  </template>
						</el-table-column>
						<el-table-column
						  label="支付方式"
						  width="100">
						  <template slot-scope="scope">
							{{ scope.row.payType==0?'0元支付':scope.row.payType==1?'支付宝支付':'微信支付' }}
						  </template>
						</el-table-column>
						<el-table-column
						  label="支付状态"
						  width="100">
						  <template slot-scope="scope">
							<span v-bind:class="['ghuj',{'color0':scope.row.payState===3,'color1':scope.row.payState===2,'color2':scope.row.payState===4,'color3':scope.row.payState===1}]"></span> {{ scope.row.payState===1?'待支付':scope.row.payState===2?'已支付':scope.row.payState===4?'已过期':scope.row.payState===3?'失败':'' }}
						  </template>
					    </el-table-column>
						<el-table-column
						  label="开票状态"
						  align="center"
						  width="100">
						  <template slot-scope="scope">
							<span v-if="scope.row.payState!=1" v-bind:class="['ghuj',{'color0':scope.row.invoiceState===1,'color3':scope.row.invoiceState===2,'color1':scope.row.invoiceState===3}]"></span> {{ scope.row.invoiceState===0?'—':scope.row.invoiceState===1?'待开票':scope.row.invoiceState===2?'已提交':scope.row.invoiceState===3?'已开票':'-' }}
						  </template>
						</el-table-column>
						  
						</el-table-column>
					    <el-table-column label="操作" width="100">
					      <template slot-scope="scope">
					        <span class="guuus" @click="handleEdit(getText(scope.row.invoiceState,scope.row.payState),scope.row)">
								{{getText(scope.row.invoiceState,scope.row.payState)}}
							</span>
					      </template>
					    </el-table-column>
					  </el-table>
  <div class="wdwds" v-if="tableData.length===0">
  <img src="../../../assets/kong/kong_.png" alt=""/>
  <p>{{ifSearch?"暂无搜索结果":'暂无订单'}}</p>
					  </div>
				</div>
			</div>
			
		    <router-view></router-view>
		</div>
		<div v-if="showDetail" class="gdejf">
			<div class="rthss">
				<i @click="showDetail=false;$cookies.remove('chargeOrderId')">我的订单/</i><span class="deew">查看详情</span>
			</div>
			<div class="nyr6s">
				<h5>订单信息</h5>
				<ul>
					<li>订单编号：{{oderDetail.chargeOrderNo}}</li>
					<li>订单金额：{{oderDetail.amount}}元</li>
					<li>订单时间：{{oderDetail.orderTime}}</li>
					<li>支付方式：{{oderDetail.payType===1?'支付宝':'微信'}}</li>
					<li>支付时间：{{oderDetail.payTime}}</li>
				</ul>
			</div>
			<div class="nyr6s">
				<h5>发票信息</h5>
				<ul>
					<li>发票类型：{{oderDetail.type===0?'增值税普通发票':'增值税专用发票'}}</li>
					<li>发票内容：{{oderDetail.content}}</li>
					<li>公司名称：{{oderDetail.orgName}}</li>
					<li>纳税人识别号：{{oderDetail.taxpayerNum}}</li>
					<li>开户行：{{oderDetail.bank}}</li>
					<li>账号：{{oderDetail.bankAccount}}</li>
					<li>联系人：{{oderDetail.addressee}}</li>
					<li>联系电话：{{oderDetail.phone}}</li>
					<li>公司地址：{{oderDetail.address}}</li>
				</ul>
			</div>
			<div class="nyr6s dww">
				<h5>物流信息</h5>
				<ul>
					<li>物流公司：{{oderDetail.logistics || '--'}}</li>
					<li>物流单号：{{oderDetail.trackNum || '--'}}</li>
				</ul>
			</div>
		</div>
		
		<el-dialog :visible.sync="editPop" title="发票信息" width="520px">
			<div class="otehs" v-loading="loading">
				<el-form :model="editForm" ref="editForm" :rules="rules" label-width="100px">
				  <h6 class="pphss">发票信息</h6>
				  <div class="rsaas">
					  <el-form-item label="发票类型" prop="type">
					      <el-radio-group @change="changeType('editForm')" v-model="editForm.type">
					        <el-radio :label="1">增值税专用发票</el-radio>
					        <el-radio :label="0">增值税普通发票</el-radio>
					      </el-radio-group>
					    </el-form-item>
					  <el-form-item label="发票金额">
					    <p style="text-align: left;">{{requestObj.amount}}元</p>
					  </el-form-item>
					  <el-form-item label="发票内容">
					    <p style="text-align: left;">{{fixedDetail.content}}</p>
					  </el-form-item>
					  <el-form-item label="公司名称">
					    <p style="text-align: left;">{{fixedDetail.orgName}}</p>
					  </el-form-item>
				  </div>
				  <el-form-item prop="taxpayerNum" label="纳税人识别号">
					<el-input placeholder="请输入纳税人识别号" v-model="editForm.taxpayerNum" autocomplete="off" clearable></el-input>
				  </el-form-item>
				  
				  <el-form-item v-if="editForm.type===1" prop="bank" label="开户行">
					<el-input placeholder="请输入开户行" v-model="editForm.bank" autocomplete="off" clearable></el-input>
				  </el-form-item>
				  
				  <el-form-item v-if="editForm.type===1" prop="bankAccount" label="账号">
					<el-input placeholder="请输入账号" v-model="editForm.bankAccount" autocomplete="off" clearable></el-input>
				  </el-form-item>
				  <h6 class="pphss">收件信息</h6>
				  <el-form-item prop="address" label="邮寄地址">
					<el-input placeholder="请输入邮寄地址" v-model="editForm.address" autocomplete="off" clearable></el-input>
				  </el-form-item>
				  <el-form-item prop="addressee" label="联系人">
					<el-input placeholder="请输入联系人" v-model="editForm.addressee" autocomplete="off" clearable></el-input>
				  </el-form-item>
				  <el-form-item prop="phone" label="联系电话">
					<el-input placeholder="请输入联系电话" v-model="editForm.phone" autocomplete="off" clearable></el-input>
				  </el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
				  <el-button @click="editPop = false">取 消</el-button>
				  <el-button type="primary" @click="submit('editForm')">确 定</el-button>
				</div>
				<div class="byus">
					<h6>温馨提示：</h6>
					<p>1.开票金额超过1万元，包邮费；开票金额低于1万元，从账户余额中扣除<span>20元</span>邮费。</p>
					<P>2.用户在提交开票申请后，增值税专用发票会在<span>10</span>个工作日内审核开具；普通发票会在<span>5</span>个工作日内开具。</p>
					<p>3.请仔细核对以上填写的信息准确无误。</p>
				</div>
			</div>
		</el-dialog>
		
		<div class="mengban" v-show="dialogFormVisible">
		  <div class="iuhgg">
			  <img class="close" @click="closeWecat" src="../../../assets/close.png" alt="关闭">
			  <div class="rthjs">
				  <div class="ffhs">微信支付</div>
				  <div class="ugtgw">
					  <div class="iuyyy">
						  <!-- <img class="qr" src="../../assets/qr.png"/> -->
						  <div class="qrcode" ref="qrCodeUrl" v-if="codeHtml"></div>
						  <div class="ergh">
							  <img src="../../../assets/saomiao.png" alt=""/>
							  <div class="rghjs">
								  <p>请用微信扫一扫</p>
								  <p>扫描二维码支付</p>
							  </div>
						  </div>
					  </div>
					  <div class="hhuu">
						 <p>充值金额: {{wechat1}}</p> 
						 <p>订单编号: {{wechat2}}</p>
						 <p>实付金额: <span>{{wechat3}}</span></p>
						 <p class="vgyuik">请在<span>{{daojishi}}</span>内完成支付</p>
					  </div>
				  </div>
			  </div>
		  </div>
		</div>
	</div>
</template>
<script>
import secret from '../../../components/secret.vue'
import QRCode from 'qrcodejs2'
import { payApi } from '@/api'

let timer = null
let chatTimer = null
export default {
    namme:'case5',
	components:{
	  secret
	},
    data(){
		var validatePhone = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入联系电话'));
			}
			if(!/^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(value)) {
				callback(new Error('请输入正确手机号'));
			}
			callback();
		};
		
		var validateID = (rule, value, callback) => {
		  if (!value) {
			callback(new Error('请输入纳税人识别号'));
		  }
		  callback()
		};
		
		var validateBankAdress = (rule, value, callback) => {
		  if (this.editForm.type===1 && !value) {
			callback(new Error('请输入开户行'));
		  }
		  callback()
		};
		
		var validateBankAccount =(rule, value, callback)=> {
			if (this.editForm.type===1 && !value) {
				callback(new Error('请输入银行账号'));
			}
			callback()
		}
		
		var validateAdress = (rule, value, callback)=> {
			if (!value) {
				callback(new Error('请输入公司地址'));
			}
			callback()
		}
		
		var validateContact = (rule, value, callback)=> {
			if (!value) {
				callback(new Error('请输入联系人'));
			}
			callback()
		}
        return{
			input1: '',
			date:'',
			repayType: '',
			payState: '',
			fapiao: '',
			options01: [{
			  value: 0,
			  label: '全部'
			},{
			  value: 1,
			  label: '支付宝支付'
			}, {
			  value: 2,
			  label: '微信支付'
			}],
			options02: [ {
			  value: 0,
			  label: '全部'
			},{
			  value: 1,
			  label: '待支付'
			}, {
			  value: 2,
			  label: '已支付'
			},{
			  value: 3,
			  label: '失败'
			}, {
			  value: 4,
			  label: '已过期'
			}],
			options03: [{
			  value: 0,
			  label: '全部'
			},{
			  value: 1,
			  label: '待开票'
			},{
			  value: 2,
			  label: '已提交'
			}, {
			  value: 3,
			  label: '已开票'
			}],
			codeHtml: true,
			// filters01: '',
			// filters02: '',
			editPop: false,
			tableData: [],
			editForm: {
			  type: 1,
			  taxpayerNum: '',
			  bank: '',
			  bankAccount: '',
			  address: '',
			  addressee: '',
			  phone: ''
			},
			dialogFormVisible: false,
			daojishi: '00:00:00',
			start: 3600,
			wechat1: '',
			wechat2: '',
			wechat3: '',
			ifSearch: false,
			rules: {
			  taxpayerNum: [
				{ validator: validateID, trigger: 'blur' }
			  ],
			  bank: [
				{ validator: validateBankAdress, trigger: 'blur' }
			  ],
			  bankAccount: [
			  	{ validator: validateBankAccount, trigger: 'blur' }
			  ],
			  address: [
			  	{ validator: validateAdress, trigger: 'blur' }
			  ],
			  addressee: [
			  	{ validator: validateContact, trigger: 'blur' }
			  ],
			  phone: [
				  { validator: validatePhone, trigger: 'blur' }
			  ]
			},
			loading: false,
			showDetail: false,
			userInfo: {},
			pages: 1,
			requestObj: {},
			oderDetail: {},
			fixedDetail: {}
        }
    },
	watch: {
		editPop: function(newVal,oldVal) {
			if (newVal) {
				this.$store.commit('setOtherMeng',1)
			} else {
				this.$store.commit('setOtherMeng',0)
			}
		}
	},
	beforeDestroy() {
		this.$cookies.remove('chargeOrderId')
		clearInterval(timer)
		clearInterval(chatTimer)
	},
    methods:{
		closeWecat() {
		  this.dialogFormVisible=false;
		  this.codeHtml=false
		  clearInterval(timer)
		  clearInterval(chatTimer)
		  let _this = this
		  setTimeout(function(){
			  _this.codeHtml=true
		  },50)
		},
		getOrderId(val) {
			if(!val) return
			this.orderId = val
			this.getCase()
		},
		changeType(formName) {
			// this.editForm.taxpayerNum = ''
			this.editForm.bank = ''
			this.editForm.bankAccount = ''
			// this.editForm.address = ''
			this.editForm.addressee = ''
			this.editForm.phone = ''
			this.$nextTick(()=>{
			   this.$refs[formName].clearValidate();
			})
		},
		goSearch() {
			this.ifSearch = true
			this.getCase()
		},
		checkState(val) {
			let _this = this
			let params = {
				chargeOrderNo: val
			}
			chatTimer = setInterval(function(){
				payApi.getChargeOrderState(params)
				  .then((res) =>{
					  if (res.state===200) {
						  if (res.data === 'SUCCESS') {
							  clearInterval(chatTimer)
							  _this.dialogFormVisible = false
							  _this.$message.success('充值成功');
						  }
					  } else {
						  _this.$message.error(res.message);
					  }
				  })
				  .catch(err=>{
					  _this.$message.error(err);
				  })
			},5000)
		},
		getCase:function(page){
			let startTime = ''
			let endTime = ''
			if (this.date) {
				let date1 = this.date[0]
				let date2 = this.date[1]
				startTime = date1.getFullYear()+'-'+(date1.getMonth()+1)+'-'+date1.getDate()
				endTime = date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate()
			}
		    let params = {
				  orderId: this.orderId,
				  chargeOrderNo: this.input1,
				  startTime: startTime,
				  endTime: endTime,
				  payType: this.repayType,
				  payState: this.payState,
				  invoiceState: this.fapiao,
				  pageNum: 1
			  }
			  let newParams = {}
			  for (let key in params) {
				  if (params[key]) {
					  newParams[key] = params[key]
				  }
			  }
			this.tableLoading = true
		    payApi.getChargeOrders(newParams)
			  .then((res) =>{
				  console.log(res)
				  if (res.state===200) {
					
				  } else {
					this.$message.error(res.message);
				  }
				  try{
				  	this.tableData = res.data
					this.pages = res.data.total
				  }catch(e){
				  	//TODO handle the exception
				  }
					  this.tableLoading = false
			  })
			  .catch(err=>{
				  this.tableLoading = false
				  alert(err);
			  })
		},
		handleEdit(text,obj) {
			if (text==='删除') {
				this.$confirm('确定删除选中的订单吗',{type: 'warning'})
				  .then(_ => {
					  // /pay/charge/order/del orderId	
					this.delOrder(obj.id)
					done();
				  })
				  .catch(_ => {});
			} else if (text==='去支付') {
				// this.$router.push('/charge')
				this.goCharge(obj)
			} else if (text==='开发票') {
				// this.$refs['editForm'].resetFields();
				this.getFixed()
				// this.getOrderDetail(obj.id)
				this.editForm.type = 1
				this.changeType('editForm')
				this.editPop = true
			} else if (text==='查看详情') {
				this.$cookies.set('chargeOrderId', obj.id, { expires: 1 })
				this.getOrderDetail(obj.id)
				this.showDetail = true
			}
			this.requestObj = obj
		  },
		  submit(form) {
			let para = Object.assign(this.editForm,this.fixedDetail,this.requestObj)
			let newParams = {}
			for (let key in para) {
			  console.log(key)
			  console.log(key === 'id')
			  if (key === 'id') {
				  newParams['chargeOrderId'] = para[key]
			  } else {
				  newParams[key] = para[key]
			  }
			}
		    this.$refs[form].validate((valid) => {
		  	if (valid) {
		  		this.loading = true
		  		payApi.addInvoice(newParams)
		  		  .then((res) =>{
		  			  this.editPop = false
					  this.getCase()
					  this.loading = false
		  		  })
		  		  .catch(err=>{
		  			  this.loading = false
		  			  this.$message.error(err);
		  		  })
		  	} else {
		  	  console.log('error submit!!');
		  	  return false;
		  	}
		    });
		  },
		  backTime() {
		  	let _this = this
		  	clearInterval(timer)
		  	// _this.start = 3600
		  	_this.solveTime(_this.start)
		  	timer = setInterval(function(){
		  		_this.start--
		  		_this.solveTime(_this.start)
		  	},1000)
		  },
		  solveTime(miao) {
		  	if(miao<=1) {
		  		this.daojishi = '00:00:00'
		  		clearInterval(timer)
		  		return
		  	}
		  	let min = parseInt(miao/60)
		  	let sec = miao%60
		  	this.daojishi = `00:${min<10?'0'+min:min}:${sec<10?'0'+sec:sec}`
		  },
		  goCharge(obj) {
			let params = {
				  id: obj.id
			  }
			payApi.continueCharge(params)
			  .then((res) =>{
				  console.log(res)
				  if (res.state===200) {
					if (res.data.url === 'success') {
						this.successCall()
					} else if(res.data.url === 'fail'){
						this.failCall()
					} else {
						if (obj.payType===1) {
							const newWindow = window.open('', '_blank');
							newWindow.document.write(res.data.url);
							newWindow.focus();
						} else if (obj.payType===2) {
							this.creatQrCode(res.data.url)
							this.wechat1 = res.data.chargeOption
							this.wechat2 = res.data.chargeOrderNo
							this.wechat3 = res.data.paidAmount
							this.dialogFormVisible = true
							let haomiao = new Date().getTime()-new Date(obj.orderTime).getTime()
							this.start = 3600 - parseInt(haomiao/1000)
							this.backTime()
							this.checkState(res.data.chargeOrderNo)
						}
					}
				  } else {
					this.$message.error(res.message);
				  }
				 
			  })
			  .catch(err=>{
				  this.$message.error(err);
			  })  
		  },
		  creatQrCode(url) {
		  	var qrcode = new QRCode(this.$refs.qrCodeUrl, {
		  		text: url, // 需要转换为二维码的内容
		  		width: 132,
		  		height: 132,
		  		colorDark: '#000000',
		  		colorLight: '#ffffff',
		  		correctLevel: QRCode.CorrectLevel.H
		  	})
		  },
		  getText(invoiceState,payState) {
			  if (payState===1) {
				  return '去支付'
			  } 
			  if(payState===4) {
				return '删除'
			  }
			  if (invoiceState===1) {
				  return '开发票'
			  } else if (invoiceState===2) {
				  return '查看详情'
			  } else if (invoiceState===3) {
				  return '查看详情'
			  }
		  },
		  getFixed() {
			let params = {
				  userId: this.$cookies.getJSON('user').userId,
				  orderId:this.orderId
			}
			payApi.getInvoiceFixedInfo(params)
			.then((res) =>{
				  console.log(res)
				  if (res.state===200) {
					this.fixedDetail = res.data
					this.editForm.taxpayerNum = res.data.taxpayerNum
					this.editForm.address = res.data.address
				  } else {
					this.$message.error(res.message);
				  }
			})
			.catch(err=>{
			  alert(err);
			})  
		  },
		  getOrderDetail(orderId) {
			  let params = {
				  userId: this.$cookies.getJSON('user').userId,
				  chargeOrderId:orderId
			  }
			  payApi.getInvoiceDetail(params)
			  .then((res) =>{
				  console.log(res)
				  if (res.state===200) {
					this.oderDetail = res.data
					this.editForm = res.data
				  } else {
					this.$message.error(res.message);
				  }
			  })
			  .catch(err=>{
				  alert(err);
			  })
		  },
		  // initFapiao(res): {
			 //  editForm: {
			 //    type: 1,
			 //    taxpayerNum: '',
			 //    bank: '',
			 //    bankAccount: '',
			 //    address: '',
			 //    addressee: '',
			 //    phone: ''
			 //  },
			 //  address
			 //  : 
			 //  "dwedwed"
			 //  addressee
			 //  : 
			 //  "dwedewd"
			 //  amount
			 //  : 
			 //  "5000.00"
			 //  bank
			 //  : 
			 //  "dwedewd"
			 //  bankAccount
			 //  : 
			 //  "dwedewd"
			 //  chargeOrderId
			 //  : 
			 //  2
			 //  chargeOrderNo
			 //  : 
			 //  "20221130182518448350"
			 //  content
			 //  : 
			 //  "*信息技术服务*信息技术服务费"
			 //  logistics
			 //  : 
			 //  null
			 //  orderTime
			 //  : 
			 //  "2022-11-30T10:25:18.000+00:00"
			 //  orgName
			 //  : 
			 //  "北京百度网讯科技有限公司"
			 //  payTime
			 //  : 
			 //  "2022-12-01T10:26:04.000+00:00"
			 //  payType
			 //  : 
			 //  2
			 //  phone
			 //  : 
			 //  "13161257792"
			 //  state
			 //  : 
			 //  0
			 //  taxpayerNum
			 //  : 
			 //  "91110000802100433B"
			 //  trackNum
			 //  : 
			 //  null
			 //  type
			 //  : 
			 //  0
			 //  this.editForm = res
		  // }
		  delOrder(orderId) {
			  let params = {
				  userId: this.$cookies.getJSON('user').userId,
				  orderId:orderId
			  }
			  payApi.deleteChargeOrder(params)
			  .then((res) =>{
				  console.log(res)
				  if (res.state===200) {
					this.getCase()
					this.$message.success('订单已删除');
				  } else {
					this.$message.error(res.message);
				  }
			  })
			  .catch(err=>{
				  alert(err);
			  })
		  },
		  // initFapiao:function() {
			  
		  // },
		  getFapiao:function(){
		      let params = {
		  		  userId: this.$cookies.getJSON('user').userId,
		  		  orderId: this.requestObj.id
		  	  }
		      payApi.getInvoiceDetail(params)
		  	  .then((res) =>{
		  		  console.log(res)
		  		  if (res.state===200) {
		  			
		  		  } else {
		  			this.$message.error(res.message);
		  		  }
		  		  this.userInfo = res.data
		  	  })
		  	  .catch(err=>{
		  		  alert(err);
		  	  })
		  },
    },
    mounted() {
    	this.$store.commit('setCenterIndex',4)
		let chargeOrderId = this.$cookies.get('chargeOrderId')
		if (chargeOrderId) {
			this.getOrderDetail(chargeOrderId)
			this.showDetail = true
		}
    }
}
</script>



// WEBPACK FOOTER //
// src/views/center/caseChild/case5.vue